import React from 'react';

type Icons =
  | 'dacademic-cap'
  | 'done'
  | 'pointer-left'
  | 'triangle-down'
  | 'alert'
  | 'arrow-down'
  | 'arrow-left'
  | 'arrow-right'
  | 'arrow-up'
  | 'calendar'
  | 'checked'
  | 'close'
  | 'clear'
  | 'edit'
  | 'help'
  | 'options'
  | 'padlock-locked'
  | 'padlock-unlocked'
  | 'play'
  | 'plus'
  | 'pointer-down'
  | 'pointer-right'
  | 'pointer-up'
  | 'preloader'
  | 'reload'
  | 'reset'
  | 'search'
  | 'share'
  | 'shield'
  | 'star'
  | 'trash'
  | 'triangle-right'
  | 'triangle-up'
  | 'user'
  | 'triangle-left'
  | 'map'
  | 'printer'
  | 'heart'
  | 'align-center'
  | 'align-left'
  | 'align-right'
  | 'notifications'
  | 'email'
  | 'star-full'
  | 'map-1'
  | 'prescription'
  | 'protocols'
  | 'done-fill'
  | 'world'
  | 'md-spin';

interface Props {
  name: Icons;
  className?: string;
}

const Icon: React.FC<Props> = ({ name, className }: Props) => <i className={`md-icon ${name} ${className}`} />;

export default Icon;
